// Port of ScreenRemovedScreen() in android/.../ui/MainActivity.kt.
// State: backend returned 404 from /content — the Screen row was deleted.
// usePlayerState has already wiped credentials at this point. We tell the
// operator to reload the page so the player can auto-register fresh.
//
// On Android the equivalent guidance is "close and reopen the app". On web
// the natural action is a hard refresh: Ctrl+R / F5.

import { DISCONNECT_CODES } from '../lib/disconnectCodes'
import DisconnectCode from './DisconnectCode'

export default function ScreenRemovedScreen() {
  return (
    <div className="flex flex-col items-center gap-3 px-12 text-center max-w-md">
      <h2 className="text-white text-[22px] font-semibold">
        Screen has been removed
      </h2>
      <p className="text-muted text-sm leading-relaxed">
        Reload this page to connect again.
      </p>
      <DisconnectCode code={DISCONNECT_CODES.REMOVED} />
    </div>
  )
}
